import { useState } from "react";
import { Col, Container, Form, FormGroup, Row, Label, Input, Button } from "reactstrap";
import Header from "./shared/Header";
import Swal from "sweetalert2";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";

const initialContact = {
    nombre: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    empresa: ''
};

const initialCredentials = {
    email: '',
    password: '',
    confirmPassword: '',
    codigoAcceso: ''
};

function validateConfirmPassword(password, confirmPassword) {
    if (!confirmPassword.trim()) {
        return 'Debes confirmar tu contraseña.';
    }
    if (password !== confirmPassword) {
        return 'Las contraseñas no coinciden.';
    }
    return null;
}

export default function Register() {
    const [step, setStep] = useState(1);
    const [contactData, setContactData] = useState(initialContact);
    const [credentialsData, setCredentialsData] = useState(initialCredentials);
    const [confirmPasswordError, setConfirmPasswordError] = useState('');

    const history = useHistory();

    function handleContactChange(name) {
        return function (e) {
            setContactData({ ...contactData, [name]: e.target.value });
        };
    }

    function handleCredentialsChange(name) {
        return function (e) {
            const value = e.target.value;
            const nextCredentials = { ...credentialsData, [name]: value };
            setCredentialsData(nextCredentials);

            if (name === 'confirmPassword' || name === 'password') {
                const confirmPassword = name === 'confirmPassword' ? value : nextCredentials.confirmPassword;
                const password = name === 'password' ? value : nextCredentials.password;
                if (confirmPassword) {
                    setConfirmPasswordError(validateConfirmPassword(password, confirmPassword));
                } else {
                    setConfirmPasswordError('');
                }
            }
        };
    }

    function handleFirstStepSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        setStep(2);
    }

    function handleSendAccessCode() {
        const email = credentialsData.email.trim();
        if (!email) {
            Swal.fire({
                icon: 'error',
                title: 'Email requerido',
                text: 'Ingresa tu correo electrónico antes de solicitar el código.',
                confirmButtonText: 'Continuar',
                confirmButtonColor: '#6c757d',
            });
            return;
        }

        console.log('Enviar código de acceso (solo frontend):', email);
        Swal.fire({
            icon: 'info',
            title: 'Código en preparación',
            text: `Próximamente se enviará un código a ${email}.`,
            confirmButtonText: 'Continuar',
            confirmButtonColor: '#6c757d',
        });
    }

    function handleSecondStepSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        const confirmError = validateConfirmPassword(
            credentialsData.password,
            credentialsData.confirmPassword
        );
        if (confirmError) {
            setConfirmPasswordError(confirmError);
            Swal.fire({
                icon: 'error',
                title: 'Contraseña no válida',
                text: confirmError,
                confirmButtonText: 'Continuar',
                confirmButtonColor: '#6c757d',
            });
            return;
        }

        if (!credentialsData.codigoAcceso.trim()) {
            Swal.fire({
                icon: 'error',
                title: 'Código requerido',
                text: 'Ingresa el código de acceso que recibiste en tu correo electrónico.',
                confirmButtonText: 'Continuar',
                confirmButtonColor: '#6c757d',
            });
            return;
        }

        const { confirmPassword, ...credentialsForServer } = credentialsData;
        const payload = { ...contactData, ...credentialsForServer };
        console.log('Registro (solo frontend):', payload);

        Swal.fire({
            icon: 'info',
            title: 'Registro en preparación',
            text: 'Los datos se capturaron correctamente. La conexión con el servidor se implementará próximamente.',
            confirmButtonText: 'Continuar',
            confirmButtonColor: '#6c757d',
        }).then(() => {
            history.push('/wizard');
        });
    }

    if (step === 1) {
        return (
            <div>
                <Form onSubmit={handleFirstStepSubmit}>
                    <Header>Formulario de registro</Header>
                    <FormGroup>
                        <Container>
                            <p>Por favor, completa el formulario para crear tu cuenta.</p>
                            <Row>
                                <Col xs="3">
                                    <Label for="nombre">Nombres *</Label>
                                </Col>
                                <Col xs="auto">
                                    <Input
                                        type="text"
                                        id="nombre"
                                        name="nombre"
                                        className="FormInput"
                                        value={contactData.nombre}
                                        onChange={handleContactChange('nombre')}
                                        required
                                    />
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col xs="3">
                                    <Label for="apellidoPaterno">Apellido Paterno *</Label>
                                </Col>
                                <Col xs="auto">
                                    <Input
                                        type="text"
                                        id="apellidoPaterno"
                                        name="apellidoPaterno"
                                        className="FormInput"
                                        value={contactData.apellidoPaterno}
                                        onChange={handleContactChange('apellidoPaterno')}
                                        required
                                    />
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col xs="3">
                                    <Label for="apellidoMaterno">Apellido Materno</Label>
                                </Col>
                                <Col xs="auto">
                                    <Input
                                        type="text"
                                        id="apellidoMaterno"
                                        name="apellidoMaterno"
                                        className="FormInput"
                                        value={contactData.apellidoMaterno}
                                        onChange={handleContactChange('apellidoMaterno')}
                                    />
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col xs="3">
                                    <Label for="empresa">Empresa</Label>
                                </Col>
                                <Col xs="auto">
                                    <Input
                                        type="text"
                                        id="empresa"
                                        name="empresa"
                                        className="FormInput"
                                        value={contactData.empresa}
                                        onChange={handleContactChange('empresa')}
                                    />
                                </Col>
                            </Row>
                            <br />
                            <br />
                            <Row>
                                <Col xs="10">
                                    <Link to="/login">¿Ya tienes una cuenta? Inicia sesión aquí</Link>
                                </Col>
                                <Col xs="2">
                                    <Button color="secondary" type="submit">Continuar</Button>
                                </Col>
                            </Row>
                        </Container>
                    </FormGroup>
                </Form>
            </div>
        );
    }

    return (
        <div>
            <Form onSubmit={handleSecondStepSubmit}>
                <Header>Creación de cuenta</Header>
                <FormGroup>
                    <Container>
                        <p>Por favor, completa el formulario para crear tu cuenta.</p>
                        <Row>
                            <Col xs="3">
                                <Label for="email">Email *</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="email"
                                    id="email"
                                    name="email"
                                    className="FormInput"
                                    value={credentialsData.email}
                                    onChange={handleCredentialsChange('email')}
                                    required
                                />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col xs="3">
                                <Label for="password">Contraseña *</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="password"
                                    id="password"
                                    name="password"
                                    className="FormInput"
                                    value={credentialsData.password}
                                    onChange={handleCredentialsChange('password')}
                                    required
                                />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col xs="3">
                                <Label for="confirmPassword">Confirmar contraseña *</Label>
                            </Col>
                            <Col xs="auto">
                                <Input
                                    type="password"
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    className="FormInput"
                                    value={credentialsData.confirmPassword}
                                    onChange={handleCredentialsChange('confirmPassword')}
                                    invalid={Boolean(confirmPasswordError)}
                                    required
                                />
                                {confirmPasswordError && (
                                    <small className="text-danger">{confirmPasswordError}</small>
                                )}
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col xs="3">
                                <Label for="codigoAcceso">Código de acceso *</Label>
                            </Col>
                            <Col xs="auto">
                                <div className="d-flex align-items-center flex-wrap">
                                    <Input
                                        type="text"
                                        id="codigoAcceso"
                                        name="codigoAcceso"
                                        className="FormInput"
                                        value={credentialsData.codigoAcceso}
                                        onChange={handleCredentialsChange('codigoAcceso')}
                                        autoComplete="one-time-code"
                                        required
                                    />
                                    <Button
                                        color="secondary"
                                        type="button"
                                        className="ms-2"
                                        onClick={handleSendAccessCode}
                                    >
                                        {`Enviar Código a ${credentialsData.email.trim() || '…'}`}
                                    </Button>
                                </div>
                                <small className="text-muted">
                                    Revisa tu correo: enviamos un código para confirmar tu email y verificar que la cuenta te pertenece.
                                </small>
                            </Col>
                        </Row>
                        <br />
                        <br />
                        <Row>
                            <Col xs="10">
                                <Button color="link" type="button" className="p-0" onClick={() => setStep(1)}>
                                    Volver al paso anterior
                                </Button>
                            </Col>
                            <Col xs="2">
                                <Button color="secondary" type="submit">Registrar</Button>
                            </Col>
                        </Row>
                    </Container>
                </FormGroup>
            </Form>
        </div>
    );
}
